import { ThemeOptions } from '@mui/material';

import { responsiveStyles } from '../../theme/breakpoints';
import { tokens } from '../../theme/generated/tokens';

export const drawerTheme: ThemeOptions['components'] = {
  DsDrawerOverlay: {
    styleOverrides: {
      root: {
        position: 'absolute',
        inset: 0,
        zIndex: '2',
        paddingTop: '30vh',
      },
      opaqueOverlay: {
        position: 'absolute',
        inset: 0,
        backgroundColor: tokens.theme.bg.structural.surface,
        opacity: 0.9,
      },
      contentWrapper: {
        position: 'relative',
      },
    },
  },
  MuiDrawer: {
    defaultProps: {
      hideBackdrop: false,
    },
    styleOverrides: {
      root: {
        '&.DS-Drawer-no-backdrop': {
          left: 'unset',
        },

        '& .MuiBackdrop-root': {
          backgroundColor: 'unset',
        },
      },
      paper: {
        boxShadow: tokens.theme.shadows.elevation.high,
        '&.DS-Drawer-size': {
          '&XXsmall': {
            width: 300,
            ...responsiveStyles({
              lg: { width: 300 },
            }),
          },
          '&Xsmall': {
            width: 384,
            ...responsiveStyles({
              lg: { width: 384 },
            }),
          },
          '&Small': {
            width: 480,
            ...responsiveStyles({
              lg: { width: 480 },
            }),
          },
          '&Medium': {
            width: 704,
            ...responsiveStyles({
              lg: { width: 704 },
            }),
          },
          '&Large': {
            width: 864,
            ...responsiveStyles({
              lg: { width: 864 },
            }),
          },
          '&Xlarge': {
            width: 960,
            ...responsiveStyles({
              lg: { width: 960 },
            }),
          },
          '&Xxlarge': {
            width: 1024,
            ...responsiveStyles({
              lg: { width: 1024 },
            }),
          },
        },
        '&.DS-Drawer-color': {
          '&Primary': {
            backgroundColor: tokens.theme.bg.structural.surface,
            color: tokens.theme.fg.structural.primary,
          },
          '&Secondary': {
            backgroundColor: tokens.theme.bg.structural.surfaceInverse,
            color: tokens.theme.fg.structural.primaryOnInverse,

            '& .DS-CloseDrawerButton-root': {
              color: tokens.theme.fg.structural.secondaryOnInverse,
              '&:hover': { backgroundColor: 'unset' },
            },
          },
        },
      },
    },
  },
};
